import type { ToolMeta } from './registry';

export const findChecklistTasksMeta = {
  description:
    "Find a checklist task by name in the couple's app, as {id, name, done} — for the id of a task to act on.",
  examples: ['Mark "Order wedding cake" as done', 'Untick the venue task, I unbooked it'],
  value: 'a task on their checklist, found by name',
  grounding: 'planning-timeline',
} as const satisfies ToolMeta;
